import React from "react";
import { Modal, Descriptions, Button } from "antd";
import { ProfileOutlined } from "@ant-design/icons";

/**
 * Popup showing the full supplier details for a document (GRN / PR / etc.).
 * Keeps the pages compact: the card shows just the supplier name and a
 * "View Supplier" button; this modal holds the complete record.
 *
 * Usage:
 *   <SupplierDetailsModal visible={visible} onCancel={...} supplier={master} />
 */
const SupplierDetailsModal = ({ visible, onCancel, supplier }) => {
  const s = supplier || {};

  return (
    <Modal
      title={
        <>
          <ProfileOutlined style={{ color: "var(--fluid-primary)", marginRight: 8 }} />
          Supplier Details{s.supplier_name ? ` — ${s.supplier_name}` : ""}
        </>
      }
      open={visible}
      onCancel={onCancel}
      width={560}
      footer={
        <Button type="primary" className="fluid-btn-primary" onClick={onCancel}>
          Close
        </Button>
      }
      destroyOnClose
    >
      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="Supplier Name">
          <strong>{s.supplier_name || "-"}</strong>
        </Descriptions.Item>
        <Descriptions.Item label="Type">{s.supplier_type || "-"}</Descriptions.Item>
        <Descriptions.Item label="Reg No">{s.supplier_reg_no || "-"}</Descriptions.Item>
        <Descriptions.Item label="Address">{s.supplier_address || "-"}</Descriptions.Item>
        <Descriptions.Item label="Land Phone">{s.supplier_landno || "-"}</Descriptions.Item>
        <Descriptions.Item label="Mobile">{s.supplier_mobile || "-"}</Descriptions.Item>
        <Descriptions.Item label="Email">{s.supplier_email || "-"}</Descriptions.Item>
        <Descriptions.Item label="Web">{s.supplier_web || "-"}</Descriptions.Item>
        <Descriptions.Item label="Note">{s.supplier_note || "-"}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default SupplierDetailsModal;
